import { SearchTeamRequest, SearchTeamResultExternal } from '@askporter/client-grieg-lyric';
import { API } from './api';

export default async ({ payload }: { payload: SearchTeamRequest }): Promise<SearchTeamResultExternal> => {
  const { data } = await API().post({ path: 'teams/search', payload });
  return data;
};
